import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";
import instance from "../utils/api_instance.util";
import { errorToastify, successToastify } from "../utils/toastify.util";

const initialState = {
	isLoader: false,
	companyList: [],
	formData: {},
};

export const getCompanyList = createAsyncThunk(
	"company/companyList",
	async () => {
		try {
			const { data } = await instance.get(`/api/v1/company/company-list`);
			return data;
		} catch (err) {
			const { data } = err.response;
			errorToastify(data.message);
		}
	}
);

export const createCompany = createAsyncThunk(
	"company/createCompany",
	async (payload, { dispatch }) => {
		try {
			const { data } = await instance.post(
				`/api/v1/company/create-company`,
				payload
			);
			if (data.success) {
				successToastify(data.mesasge);
				dispatch(getCompanyList());
			}
		} catch (err) {
			const { data } = err.response;
			errorToastify(data.message);
		}
	}
);

export const updateCompany = createAsyncThunk(
	"company/updateCompany",
	async (payload, { dispatch }) => {
		try {
			const { data } = await instance.put(
				`/api/v1/company/update-company/${payload.id}`,
				payload
			);
			if (data.success) {
				successToastify(data.mesasge);
				dispatch(getCompanyList());
			}
		} catch (err) {
			const { data } = err.response;
			errorToastify(data.message);
		}
	}
);

export const deleteCompany = createAsyncThunk(
	"company/deleteCompany",
	async (id, { dispatch }) => {
		try {
			const { data } = await instance.put(
				`/api/v1/company/update-company/${id}`,
				{ id, is_active: false }
			);
			if (data.success) {
				successToastify(data.mesasge || data.message || "Company deleted.");
				dispatch(getCompanyList());
			}
			return data;
		} catch (err) {
			const message =
				err.response?.data?.message || "Unable to delete company.";
			errorToastify(message);
			return { success: false, message };
		}
	}
);

const companySlice = createSlice({
	name: "company",
	initialState,
	reducers: {
		setFormData: (state, { payload }) => {
			state.formData = { ...state.formData, ...payload };
		},
	},
	extraReducers: (builder) => {
		builder.addCase(getCompanyList.pending, (state, action) => {
			state.isLoader = true;
		});
		builder.addCase(getCompanyList.fulfilled, (state, action) => {
			if (action.payload?.success || false) {
				state.isLoader = false;
				state.companyList = action.payload.result;
			} else {
				state.isLoader = false;
				state.companyList = [];
			}
		});
	},
});

export default companySlice.reducer;
export const { setFormData } = companySlice.actions;
